import type { EstadoTampaOficina, IdZonaOperacaoTampa } from '../../dominio/didatico/oficinaPortaMalas'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import type { FerramentaOficinaCorte } from '../../dominio/didatico/oficinaCorte'
import { chaveProgressoIntervencao, resolverInteracaoTampa } from '../../dominio/didatico/interacaoOficina'
import { estadoZonasTampa } from './estadoZonas'
import { MarcadorZona3D } from './MarcadorZona3D'
import { posicaoNoQuadroDaTampa, quadroDaTampa } from './quadroDaTampa'
import { inclinacaoDaTampaRad, zonasOperacaoTampa } from './zonasOperacaoTampa'

interface Props {
  perfil: PerfilVeiculo
  selecionada: IdZonaOperacaoTampa | null
  /** Estado da tampa: é o que faz o marcador registrar o que já foi feito ali. */
  estadoTampa: EstadoTampaOficina
  ferramenta: FerramentaOficinaCorte
  progressoEstrutural: Record<string, number>
  aoSelecionar: (id: IdZonaOperacaoTampa) => void
  /** Pressionar o marcador já começa a fechar a ferramenta — soltar em qualquer lugar interrompe (ver App.tsx). */
  aoPressionarFerramenta: (id: IdZonaOperacaoTampa) => void
  aoSoltarFerramenta: () => void
  aoPrevisualizar: (id: IdZonaOperacaoTampa) => void
}

/** Marcadores grandes o bastante para clique e toque; a ferramenta encaixa neles. */
export function ZonasOperacaoTampa3D({
  perfil,
  selecionada,
  estadoTampa,
  ferramenta,
  progressoEstrutural,
  aoSelecionar,
  aoPressionarFerramenta,
  aoSoltarFerramenta,
  aoPrevisualizar,
}: Props) {
  const estados = estadoZonasTampa(estadoTampa)
  const inclinacao = inclinacaoDaTampaRad(perfil)
  const quadro = quadroDaTampa(perfil, estadoTampa)

  if (estadoTampa.removida) return null

  return (
    <group>
      {zonasOperacaoTampa(perfil).map((zona) => {
        const intencao = resolverInteracaoTampa({ ferramenta, zona: zona.id, estado: estadoTampa })
        return <MarcadorZona3D
          key={zona.id}
          posicao={posicaoNoQuadroDaTampa(quadro, zona.posicao)}
          // o anel acompanha a inclinação da própria tampa
          rotacao={[inclinacao + quadro.giroX, 0, 0]}
          nome={zona.nome}
          descricao={intencao.descricao}
          disponivel={intencao.disponivel}
          progressoEstrutural={intencao.disponivel
            ? progressoEstrutural[chaveProgressoIntervencao(intencao.operacao, zona.id)] ?? 0
            : 0}
          estado={estados[zona.id]}
          selecionada={zona.id === selecionada}
          nomeObjeto={`zona-operacao-tampa:${zona.id}`}
          aoSelecionar={() => aoSelecionar(zona.id)}
          aoPressionarFerramenta={() => aoPressionarFerramenta(zona.id)}
          aoSoltarFerramenta={aoSoltarFerramenta}
          aoPrevisualizar={() => aoPrevisualizar(zona.id)}
        />
      })}
    </group>
  )
}
